import React from 'react'
import Container from 'src/components/Container'
import LinkCardList from 'src/components/LinkCardList'
import { StateSpinner } from 'src/components/Spinner'
import { useAllResourcesQuery } from 'shared/schema'

function ResourcesRoute() {
	const { data, loading } = useAllResourcesQuery()

	return <Container>{loading ? <StateSpinner /> : <LinkCardList data={data?.resources ?? []} />}</Container>
}

export default ResourcesRoute
